import { indexItems } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">专题索引</h2>
          <p className="mt-2 text-sm text-foreground-500">精选深度专题合集，系统了解网红黑料全貌</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#"
              className="group flex items-center gap-4 p-4 bg-background-100/80 rounded-xl border border-background-200/60 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-gradient-to-br from-primary-100 to-accent-100 text-primary-600 font-heading font-bold text-lg">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}